import { Link, useLocation } from 'react-router-dom';
import { FaArrowRight, FaLeaf, FaRoute, FaShieldAlt, FaPhoneAlt } from 'react-icons/fa';
import homeBackground from '../assets/images/home-background.jpg';
import settingsImage from '../assets/images/road-cross-green.jpg';
import arrowGreen from '../assets/images/arrow.png';
import arrowPurple from '../assets/images/arrow-purple.png';
import greenCube from '../assets/images/green-cube.png';
import backgroundPurple from '../assets/images/background-purple.jpg';
import { content, getLangFromPath } from '../i18n';

function Home() {
  const location = useLocation();
  const lang = getLangFromPath(location.pathname);
  const t = content[lang].home;
  const contactPath = lang === 'gr' ? '/gr/contact' : '/contact';

  return (
    <>
      <section
        className="hero"
        style={{ backgroundImage: `linear-gradient(rgba(23, 8, 76, 0.72), rgba(23, 8, 76, 0.78)), url(${homeBackground})` }}
      >
        <div className="container hero-inner">
          <div className="hero-card">
            <span className="eyebrow">{t.eyebrow}</span>
            <h1>
              {t.heroTitle1}
              <span>{t.heroTitle2}</span>
            </h1>
            <p>{t.heroText}</p>

            <div className="hero-actions">
              <a
                href="https://app.greenyourfreight.eu"
                target="_blank"
                rel="noreferrer"
                className="primary-btn"
              >
                {t.enterApp}
                <FaArrowRight />
              </a>

              <a
                href="https://greenyourfreight.eu"
                target="_blank"
                rel="noreferrer"
                className="secondary-btn"
              >
                {t.officialSite}
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="intro-strip">
        <div className="container intro-strip-inner">
          <div>
            <span className="mini-label">{t.introMini}</span>
            <h2>{t.introTitle}</h2>
          </div>
          <p>{t.introText}</p>
        </div>
      </section>

      <section className="section white-section">
        <div className="container two-col">
          <div>
            <div className="section-title">
              <img src={greenCube} alt="" />
              <div>
                <span>{t.aboutLabel}</span>
                <h2>{t.aboutTitle}</h2>
              </div>
            </div>

            <p className="lead-text">{t.aboutLead}</p>

            <p className="body-text">{t.aboutBody}</p>

            <ul className="icon-list">
              {t.benefits.map((item, index) => (
                <li key={index}>
                  <img src={index % 2 === 0 ? arrowGreen : arrowPurple} alt="" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="info-card purple-card">
            <div className="icon-badge">
              <FaLeaf />
            </div>
            <h3>{t.infoCardTitle}</h3>
            <p>{t.infoCardText}</p>
            
            <ul>
            <li>
              <a
                href="https://app.greenyourfreight.eu"
                target="_blank"
                rel="noreferrer"
                className="inline-link"
              >
                {t.launchPlatform} <FaArrowRight />
              </a>
            </li>
            <li>
              <a 
                href="https://play.google.com/store/apps/details?id=com.greenyourfreight.greenyourfreight&pcampaignid=web_share"
                target="_blank"
                rel="noreferrer"
                className="inline-link"
              >
                {t.downloadApp} <FaArrowRight />
              </a>
            </li>
            </ul>
          </div>
        </div>
      </section>

      <section
        className="section feature-band"
        style={{ backgroundImage: `linear-gradient(rgba(31, 10, 106, 0.93), rgba(31, 10, 106, 0.93)), url(${backgroundPurple})` }}
      >
        <div className="container">
          <div className="section-heading center light">
            <span>{t.whyLabel}</span>
            <h2>{t.whyTitle}</h2>
            <p>{t.whyText}</p>
          </div>

          <div className="feature-grid">
            <div className="feature-card">
              <FaRoute />
              <h3>{t.feature1Title}</h3>
              <p>{t.feature1Text}</p>
            </div>

            <div className="feature-card">
              <FaShieldAlt />
              <h3>{t.feature2Title}</h3>
              <p>{t.feature2Text}</p>
            </div>

            <div className="feature-card">
              <FaPhoneAlt />
              <h3>{t.feature3Title}</h3>
              <p>{t.feature3Text}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section white-section">
        <div className="container two-col reverse-mobile">
          <div className="visual-card">
            <img src={settingsImage} alt="Green settings visual" />
          </div>

          <div>
            <div className="section-title">
              <img src={greenCube} alt="" />
              <div>
                <span>{t.howLabel}</span>
                <h2>{t.howTitle}</h2>
              </div>
            </div>

            <p className="body-text">{t.howText}</p>

            <div className="steps-list">
              {t.steps.map((step, index) => (
                <div key={index} className="step-item">
                  <div className="step-number">0{index + 1}</div>
                  <p>{step}</p>
                </div>
              ))}
            </div>

            <a
              href="https://app.greenyourfreight.eu"
              target="_blank"
              rel="noreferrer"
              className="primary-btn compact"
            >
              {t.openWebApp}
              <FaArrowRight />
            </a>
            <a 
              href="https://play.google.com/store/apps/details?id=com.greenyourfreight.greenyourfreight&pcampaignid=web_share"
              target="_blank"
              rel="noreferrer"
              className="primary-btn compact downloadApp"
            >
              {t.downloadApp}
              <FaArrowRight />
            </a>
          </div>
        </div>
      </section>

      <section className="section cta-section">
        <div className="container cta-box">
          <div>
            <span className="mini-label">{t.ctaMini}</span>
            <h2>{t.ctaTitle}</h2>
            <p>{t.ctaText}</p>
          </div>

          <div className="cta-actions">
            <a
              href="https://app.greenyourfreight.eu"
              target="_blank"
              rel="noreferrer"
              className="primary-btn"
            >
              {t.enterApp}
              <FaArrowRight />
            </a>
            <Link to={contactPath} className="secondary-btn dark">
              {t.contactSupport}
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;